import React from 'react';
import Slider from 'react-slick';
import { Helmet } from 'react-helmet';
import useBlog from './../hooks/useBlog';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

const BlogSlider = () => {
  const { allBlogs } = useBlog();
  const filteredBlogs = allBlogs?.slice(0, 5);

  const settings = {
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div className='mt-3 pb-3'>
      <Helmet>
        <link
          async
          rel='stylesheet'
          type='text/css'
          charset='UTF-8'
          href='https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css'
        />
        <link
          async
          rel='stylesheet'
          type='text/css'
          href='https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css'
        />
        <link
          rel='stylesheet'
          href='https://unpkg.com/leaflet@1.7.1/dist/leaflet.css'
          integrity='sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A=='
          crossorigin=''
        />
      </Helmet>
      <Slider {...settings}>
        {filteredBlogs.map((blog) => (
          <Link
            to={blog.externalLink ? blog.externalLink : `/blog/${blog.slug}`}
            target={blog.externalLink ? '_blank' : ''}
            className='blog-slider'
          >
            <Img
              fluid={blog.coverImage.fluid}
              style={{ width: '100%', margin: '0', paddingTop: '0' }}
              objectFit='contain'
              className='slideImage'
              alt={blog.title}
            />
            <h3 className='title'>{blog.title}</h3>
          </Link>
        ))}
      </Slider>
    </div>
  );
};

export default BlogSlider;
